import { logger as LOG } from '@sweetgreen/garnish';

export const logger = LOG.extend('KUSTOMER');

LOG.disable('KUSTOMER');
